import Base from '@studiometa/js-toolkit';
import { isDev } from '../config';

/**
 * ClipCopy class
 */
export default class ClipCopy extends Base {
  /**
   * Config
   */
  get config() {
    return {
      name: 'ClipCopy',
      log: isDev(),
      content: '',
    };
  }

  /**
   * On Click
   */
  onClick() {
    if (!this.$options.content) {
      return;
    }
    const el = document.createElement('textarea');
    el.value = this.$options.content;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    this.$emit('copy', this.$options.content);
    this.changeLabel();

    setTimeout(() => {
      this.changeLabel();
    }, 2000);
  }

  /**
   * Change label of tooltip
   * @return void
   */
  changeLabel() {
    this.$refs.label.forEach((element) => {
      element.classList.toggle('hidden');
    });
  }
}
